module.exports = __webpack_public_path__ + "screen2.webp?74997b50fb890fe0f1bae4704f9e5e13";